import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, creditCardMask, currencyMask } from '~/utils/masks';

export const HeaderInvoiceDelay = [
  {
    id: 1,
    value: 'Número do Cartão',
    maxChar: 20,
    textAlign: 'center',
  },
  {
    id: 2,
    value: 'Valor',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Data Vencimento',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Dias Atraso',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Nome',
    maxChar: 22,
  },
  {
    id: 6,
    value: 'CPF',
    maxChar: 14,
    textAlign: 'center',
  },
];

export const BodyInvoiceDelay = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: creditCardMask(i.numeroCartao).masked,
        maxChar: 20,
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.saldoFaturaAtual)}`,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dtVencimento
          ? moment(i.dtVencimento).format('DD/MM/YYYY')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.diasAtraso,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.nome,
        maxChar: 22,
      },
      {
        value: i.cpf ? cpfMask(i.cpf).masked : '-',
        maxChar: 14,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
